import md5 from 'md5';

export const getSigData = (username?: string, pwd?: string) => {
  const sig = {
    data: '',
    result: username && pwd ? md5(username + pwd) : undefined,
  };
  return sig;
};
